import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const TOOTH_PATH =
    'M16 3.4c-3.6 0-5.1 2-7.7 2C6.1 5.4 4 7.1 4 10.4c0 2.7.9 4.4 1.6 6.9.5 1.9.8 4 1.3 6.1.3 1.6.7 3.1 1.7 4.1.6.6 1.5.5 2-.2.7-1 1-2.4 1.3-3.8.3-1.6.6-3.2 1.1-3.2s.8 1.6 1.1 3.2c.3 1.4.6 2.8 1.3 3.8.5.7 1.4.8 2 .2 1-1 1.4-2.5 1.7-4.1.5-2.1.8-4.2 1.3-6.1.7-2.5 1.6-4.2 1.6-6.9 0-3.3-2.1-5-4.3-5-2.6 0-4.1-2-7.7-2z'

interface LogoProps {
    className?: string
    showWordmark?: boolean
}

export const Logo: FC<LogoProps> = ({ className, showWordmark = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <span className='grid size-9 shrink-0 place-items-center rounded-lg bg-primary text-primary-foreground'>
                <svg viewBox='0 0 32 32' className='size-5' fill='currentColor' aria-hidden='true'>
                    <path d={TOOTH_PATH} />
                </svg>
            </span>

            {showWordmark && (
                <span className='font-heading text-base font-extrabold leading-none tracking-tight text-foreground'>
                    Smile Design <span className='text-primary'>Secret</span>
                </span>
            )}
        </span>
    )
}
